module.exports = __webpack_public_path__ + "img/logo1.0f64415e.png";